import { Tab, TabProps, Tabs, TabsProps } from '@mui/material';
import React from 'react';

export interface IconTab extends TabProps {
  label: string;
  icon?: React.ReactElement;
  value: string | number;
}

export interface IconTabsProps extends TabsProps {
  tabs: IconTab[];
  value: string | number;
  onChange: (event: React.SyntheticEvent, newValue: string | number) => void;
}

const IconTabs: React.FC<IconTabsProps> = ({ tabs, value, onChange, ...props }) => {
  return (
    <Tabs
      {...props}
      value={value}
      onChange={onChange}
      variant="scrollable"
      scrollButtons="auto"
      slotProps={{
        indicator: {
          style: {
            display: 'none',
          },
        },
      }}
      sx={{
        alignItems: 'center',
        '& .MuiTabs-flexContainer': { justifyContent: 'flex-end' },
      }}>
      {tabs.map(({ value, label, icon, ...props }) => (
        <Tab
          {...props}
          key={value}
          label={label}
          icon={icon}
          value={value}
          iconPosition="start"
          sx={{
            fontSize: '1.25rem',
            minHeight: 'auto',
            transition: 'background 0.2s, color 0.2s',
            borderRadius: 1,
            '&.Mui-selected': {
              borderRadius: 1,
            },
          }}
        />
      ))}
    </Tabs>
  );
};

export default React.memo(IconTabs);
